'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _iBem = require('../../i-bem/i-bem.react');

var _bKeycodes = (require('./../../keycodes/keycodes.react.js').default || require('./../../keycodes/keycodes.react.js')).applyDecls();

var _bKeycodes2 = _interopRequireDefault(_bKeycodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.declMod)(function (_ref) {
    var autoclosable = _ref.autoclosable,
        onOutsideClick = _ref.onOutsideClick;
    return autoclosable || onOutsideClick;
}, {
    block: 'popup2',
    willInit: function willInit() {
        this.__base.apply(this, arguments);

        this._onDocKeyDown = this._onDocKeyDown.bind(this);
        this._onOutsideClick = this._onOutsideClick.bind(this);
        this.toggleWatchAutoClosableEvents = this.toggleWatchAutoClosableEvents.bind(this);
    },
    didMount: function didMount() {
        this.__base.apply(this, arguments);

        if (this.props.visible) {
            this.toggleWatchAutoClosableEvents(true);
        }
    },
    willReceiveProps: function willReceiveProps(_ref2) {
        var visible = _ref2.visible;

        this.__base.apply(this, arguments);

        if (this.props.visible === visible) {
            return;
        }

        // Клик, открывающий попап, не должен рассматриваться как outsideClick.
        this._preventHideByClick = true;
        this.toggleWatchAutoClosableEvents(visible);
    },
    willUnmount: function willUnmount() {
        this.__base.apply(this, arguments);
        this.toggleWatchAutoClosableEvents(false);
    },
    toggleWatchAutoClosableEvents: function toggleWatchAutoClosableEvents(watch) {
        if (watch) {
            window.addEventListener('keydown', this._onDocKeyDown);
            window.addEventListener('click', this._onOutsideClick);
        } else {
            window.removeEventListener('keydown', this._onDocKeyDown);
            window.removeEventListener('click', this._onOutsideClick);
        }
    },
    _anchor: function _anchor() {
        var anchor = this.props.anchor;

        // TODO: https://st.yandex-team.ru/ISL-4493
        return anchor && anchor.call ? anchor() : anchor;
    },
    _isElementOutside: function _isElementOutside(element) {
        if (this.domElementPopup.contains(element) || this.isElementInsideChildPopups(element)) {
            return false;
        }

        var anchorDOM = (0, _reactDom.findDOMNode)(this._anchor());

        return !(anchorDOM && anchorDOM.contains(element));
    },
    _onOutsideClick: function _onOutsideClick(e) {
        if (this._preventHideByClick) {
            // Проверяем, не был ли клик одновременно кликом, открывающим попап.
            // Нужно для target_position.
            this._preventHideByClick = null;
            return;
        }

        if (this._isElementOutside(e.target)) {
            this.props.onOutsideClick && this.props.onOutsideClick(e);
        }
    },
    _onDocKeyDown: function _onDocKeyDown(e) {
        if (e.keyCode === _bKeycodes2.default.ESC && !this._hasOpenedChildPopups) {
            this.props.onOutsideClick && this.props.onOutsideClick(e);
        }
    }
}, {
    propTypes: {
        onOutsideClick: function onOutsideClick(_ref3) {
            var autoclosable = _ref3.autoclosable;

            return (autoclosable ? _propTypes2.default.func.isRequired : _propTypes2.default.func).apply(undefined, arguments);
        }
    }
});